import {MOON_250, WHITE} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {Banner} from '../../Banner';

export const ExternalLinks = styled(Banner)`
  background-color: ${WHITE};
  border: 1px solid ${MOON_250};
  margin: 16px 32px 16px 0;
  padding: 8px;
  flex-direction: column;
  align-items: left;
`;
ExternalLinks.displayName = 'S.ExternalLinks';

export const Header = styled.div`
  display: flex;
  width: 100%;
`;
Header.displayName = 'S.Header';

export const SectionTitle = styled.div`
  font-weight: 600;
  font-size: 20px;
  vertical-align: top;
  line-height: 0px;
  margin: 24px 0 0 8px;
`;
SectionTitle.displayName = 'S.SectionTitle';

export const LinkRow = styled.div`
  align-items: left;
  width: 100%;
  justify-content: start;
  flex-wrap: wrap;
`;
LinkRow.displayName = 'S.LinkRow';

export const Spacer = styled.div`
  flex-grow: 1;
`;
Spacer.displayName = 'S.Spacer';
